import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { FormEnums } from "models/enums";
import { BaseFormViewComponentProps, ExpandableSectionProps, FormHandles } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { DocumentFormTypes } from "models/formTypes";
//#endregion
//#region components
import { GenericForm } from "components/common";
//#endregion

const GenericDocumentTodoSelectionForm: ForwardRefRenderFunction<FormHandles, BaseFormViewComponentProps> = (
  props,
  ref
) => {
  return (
    <GenericForm<DocumentFormTypes.UploadGenericDocument>
      formRef={ref}
      {...props}
      fields={[
        {
          label: TranslationKeys.Document.YourAnswer,
          type: FormEnums.FormSectionType.EXPANDABLESECTION,
          extraProps: {
            alwaysOpen: true,
            borderless: true,
          } as ExpandableSectionProps,
          innerFields: {
            comment: {
              label: TranslationKeys.MissingDocument.ReasonHelpText,
              type: FormEnums.FormFieldType.TEXT,
              icon: IconDefinitionConstants.WCommentDots,
            },
          },
        },
        {
          label: TranslationKeys.Document.SelectPhotos,
          type: FormEnums.FormSectionType.EXPANDABLESECTION,
          extraProps: {
            alwaysOpen: true,
            borderless: true,
          } as ExpandableSectionProps,
          innerFields: {
            files: {
              label: "",
              type: FormEnums.FormFieldType.FILEUPLOADER,
              extraProps: { fileUploaderType: "full" },
            },
          },
        },
      ]}
      hideSuccess
    />
  );
};

export default forwardRef(GenericDocumentTodoSelectionForm);
